export const API_SORT_ORDER: Record<string, 1 | -1> = {
  ascend: 1,
  descend: -1
};
